module.exports = __webpack_public_path__ + "846e6199e4a8079822d8f6c956537e55.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fannie_mae_2022_chart.png
// module id = 1674
// module chunks = 0